<template>
    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="680">
      <v-card>

       <CardUpdatableHeader :row="row" :level="level"/>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="row.net_code" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._required_code')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints._code')" persistent-hint>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="row.net_cidr" :disabled="level.dialogValues.form_disabled" label="CIDR*" :rules="level.dialogOptions.dialogCIDRRules" :hint="$t('hints.net_cidr')"></v-text-field>
              </v-col>
               <v-col cols="12" sm="6" md="4">
                 <ddoSelectVlan :callbacks="VLAcallbacks" ref="mySelect" :options="VLAoptions"/>
               </v-col>
              <v-col cols="12" sm="4" md="4">
                <!-- click.native : <ipv6=ipv4>, or <ipv4=ipv6> are performed BEFORE own state changes -->
                <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.net_ipv4" @click.native ="row.net_ipv6=row.net_ipv4">{{ $t('texts.net_ipv4') }}</b-checkbox>
                <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.net_ipv6" @click.native ="row.net_ipv4=row.net_ipv6">{{ $t('texts.net_ipv6') }}</b-checkbox>
                <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.net_public">{{ $t('texts.net_public') }}</b-checkbox>
                <b-checkbox :disabled="level.dialogValues.form_disabled" v-model="row.net_deployable">{{ $t('texts.net_deployable') }}</b-checkbox>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <!-- click.native : <ipv6=ipv4>, or <ipv4=ipv6> are performed BEFORE own state changes -->
                <v-text-field v-model="row.net_subnet_regex_mask" :disabled="level.dialogValues.form_disabled" label="Regex Mask" hint="..."></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="row.net_desc"
                  :disabled="level.dialogValues.form_disabled" 
                  :label="$t('texts._desc')"
                  :hint="$t('hints._desc')"
                ></v-text-field>
              </v-col>
            </v-row>
              <v-col v-if="!level.dialogValues.form_create" cols="12">
                <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.net_create,'long') }}<br/>
                <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.net_create,'long') }}
              </v-col>
            <v-row>
            </v-row>
         </v-container>
          <small>*{{ $t('texts.requiredfield') }}</small>
        </v-card-text>

        <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
    </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelect from '@/components/ddoSelect.vue';
import ddoSelectVlan from '@/components/ddoSelectVlan.vue';

export default {
   name: 'CardUpdatableNetwork',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      ddoSelect,
      ddoSelectVlan,
      CardUpdatableHeader,
      CardUpdatableFooter
   },
   props: {
   },
   data: function () {
      return {
         VLAcallbacks: {},
         VLAoptions: {
            initial: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "vla_name",
            item_value: "vla_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.vlan'),
         },
      }
   },
   async mounted() {
      this.VLAcallbacks.refresh_rows = this.build_select_vla;
      this.VLAcallbacks.change = this.change;
   },

   methods: {
      async build_select_vla(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'vlan');
         this.loading = false;
         return { errorinfos, api_response }
      },
      async change(value,item=null) {
         if ( item!=null) {
            this.level.row.vla_pk = item.vla_pk;
         } else {
           this.level.row.vla_pk = null;
         }
      },
   }


}
</script>